// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "bridge-platform/" + "tapestry" + "." + "a86a2643c4ab349512a2" + ".css";
};